import { createAction } from '@reduxjs/toolkit'
import { userService } from '_services';
import { alertActions, dashboardActions } from '_actions';
import { history } from '_helpers';
import { ActionNames, Errors } from '_constants'
import { RouteDefs } from '_constants';
import { notificationService } from '_services';


export const userActions = {
    login: (username) => dispatch => {
        dispatch(userActions.loginRequest({ username }));

        userService.login(username)
            .then(
                user => {
                    dispatch(userActions.loginSuccess(user));
                    if (user.availableCompanies && user.availableCompanies.length === 1) {
                        dispatch(userActions.selectCompany(user.availableCompanies[0].companyId));
                    }
                    dispatch(alertActions.clear());
                },
                error => {
                    dispatch(userActions.loginFailure({ username: username, error: error }));
                    dispatch(alertActions.error(Errors.LOGIN_FAILURE));
                }
            );
    },
    loginRequest: createAction(ActionNames.LOGIN_REQUEST),
    loginSuccess: createAction(ActionNames.LOGIN_SUCCESS),
    loginFailure: createAction(ActionNames.LOGIN_FAILURE),

    forceRefresh: (force) => dispatch => {
        if (force) {
            dispatch(userActions.forceRefreshRequest());
        }
        else {
            dispatch(userActions.noRefresh());
        }
    },
    forceRefreshRequest: createAction(ActionNames.FORCE_REFRESH),
    noRefresh: createAction(ActionNames.NO_REFRESH),


    logout: () => (dispatch, getState) => {
        dispatch(userActions.logoutRequest());
        userService.saveSession(getState().ui)
            .then(() => {
                userService.logout();
                dispatch(userActions.logoutSuccess());
            },
                error => {
                    dispatch(userActions.logoutFailure());
                }
            )
        history.push('/login');
    },
    logoutRequest: createAction(ActionNames.LOGOUT_REQUEST),
    logoutSuccess: createAction(ActionNames.LOGOUT_SUCCESS),
    logoutFailure: createAction(ActionNames.LOGOUT_FAILURE),

    selectCompany: (companyId) => dispatch => {
        dispatch(userActions.selectCompanyRequest({ companyId }));

        userService.selectCompany(companyId)
            .then(
                user => {
                    dispatch(userActions.loadSession());
                    dispatch(userActions.selectCompanySuccess(user));
                    dispatch(dashboardActions.loadInitalSchedule(new Date()));
                    //dispatch(dashboardActions.load(new Date()));
                },
                error => {
                    dispatch(userActions.selectCompanyFailure({ companyId: companyId, error: error }));
                    dispatch(alertActions.error(Errors.SELECT_COMPANY_FAILURE));
                }
            );

    },
    selectCompanyRequest: createAction(ActionNames.SELECT_COMPANY_REQUEST),
    selectCompanySuccess: createAction(ActionNames.SELECT_COMPANY_SUCCESS),
    selectCompanyFailure: createAction(ActionNames.SELECT_COMPANY_FAILURE),


    saveSession: () => (dispatch, getState) => {
        dispatch(userActions.saveSessionRequest());

        userService.saveSession(getState().ui)
            .then(() => {
                dispatch(userActions.saveSessionSuccess());
            },
                error => {
                    dispatch(userActions.saveSessionFailure(error));
                }
            );
    },
    saveSessionRequest: createAction(ActionNames.SAVE_SESSION_REQUEST),
    saveSessionSuccess: createAction(ActionNames.SAVE_SESSION_SUCCESS),
    saveSessionFailure: createAction(ActionNames.SAVE_SESSION_FAILURE),


    loadSession: () => (dispatch, getState) => {
        dispatch(userActions.loadSessionRequest());

        userService.loadSession()
            .then(
                sessionData => {
                    dispatch(userActions.loadSessionSuccess(sessionData));
                    sessionData.ui.route && sessionData.ui.route.pathname ? history.push(sessionData.ui.route.pathname) : history.push(RouteDefs.therapistDashboard.path);
                    notificationService.startService();
                },
                error => {
                    dispatch(userActions.loadSessionFailure(error));
                    dispatch(alertActions.error(Errors.LOAD_SESSION_FAILURE));
                }
            )
    },
    loadSessionRequest: createAction(ActionNames.LOAD_SESSION_REQUEST),
    loadSessionSuccess: createAction(ActionNames.LOAD_SESSION_SUCCESS),
    loadSessionFailure: createAction(ActionNames.LOAD_SESSION_FAILURE),


    cetsPunchIn: () => (dispatch, getState) => {
        dispatch(userActions.cetsPunchInRequest());

        userService.cetsPunchIn()
            .then(() => {
                dispatch(userActions.cetsPunchInSuccess());
            },
                error => {
                    dispatch(userActions.cetsPunchInFailure(error));
                    dispatch(alertActions.error(Errors.CETS_PUNCH_IN_FAILURE));
                }
            )
    },
    cetsPunchInRequest: createAction(ActionNames.CETS_PUNCH_IN_REQUEST),
    cetsPunchInSuccess: createAction(ActionNames.CETS_PUNCH_IN_SUCCESS),
    cetsPunchInFailure: createAction(ActionNames.CETS_PUNCH_IN_FAILURE),

    clearCetsMessage: createAction(ActionNames.CETS_CLEAR_MESSAGE),


}
